export const portfolioData = {
  hero: {
    name: "PETE McGRAW",
    tagline: "ENTREPRENEUR • BUILDER • INNOVATOR",
    headline: "Building Ventures. Driving Innovation.",
    image: "/images/pete-mcgraw.webp"
  },
  
  about: {
    title: "ABOUT PETE",
    description: "Pete McGraw is a serial entrepreneur and AI architect. He leads Maple DX, an agentic AI consultancy for companies running on Salesforce, and founded Stratyx Ventures, which builds AI agents, websites, and apps. In 2026 he shipped Ohana Events to the App Store and built AI systems that handle sales outreach and content publishing. With 10+ ventures under his belt, MIT blockchain education, and experience spanning tech, law, and business development, Pete brings strategic vision and hands-on technical execution to every project.",
    stats: [
      { number: "10+", label: "VENTURES FOUNDED" },
      { number: "15+", label: "YEARS EXPERIENCE" },
      { number: "100+", label: "SALESFORCE BADGES" }
    ]
  },
  
  ventures: [
    {
      name: "Maple DX",
      role: "Managing Partner & CEO",
      description: "Agentic AI consultancy deploying production AI across Salesforce, AWS, Databricks, and Snowflake for B2B SaaS, FinTech, and HealthTech companies.",
      url: "https://www.mapledx.com",
      category: "Agentic AI"
    },
    {
      name: "Stratyx Ventures",
      role: "Founder and AI Architect",
      description: "AI automation, websites and apps for owner-led businesses.",
      url: "https://stratyxventures.com",
      category: "AI Automation"
    },
    {
      name: "Ohana Events",
      role: "Founder & Lead Developer",
      description: "Events app for the Salesforce community's side events. Live on the App Store since September 2026, with 450+ sign-ups during Dreamforce week and home of Dreamforce Afterhours (400+ registered).",
      url: "https://ohanaevents.app",
      category: "Event Tech"
    },
    {
      name: "Graveyard Shift",
      role: "Founder & Lead Developer",
      status: "In App Store review",
      description: "Horror movie app built for two: swipe apart, match in secret, then watch together.",
      url: "https://graveyardshift.app",
      category: "Consumer App"
    },
    {
      name: "Chiip",
      role: "Co-Founder",
      description: "Drink-gifting app for bars: guests send drinks from their phones, and bartenders redeem them from a tablet dashboard.",
      url: "https://www.chiip.app",
      category: "Social Tech"
    },
    {
      name: "Appraisal Repair",
      role: "Co-Founder",
      description: "Technology-driven solutions streamlining the real estate appraisal process.",
      url: "https://www.appraisalrepair.com",
      category: "PropTech"
    },
    {
      name: "Slushd",
      role: "Co-Founder",
      description: "Premium frozen beverage company serving music festivals with 100% juice-based, vitamin-enriched slushies. Zero added sugar, trusted by EDC, Electric Forest, and 100+ major events.",
      url: "https://www.slushd.co",
      category: "Food & Beverage"
    },
    {
      name: "Blue Mountain BPO",
      role: "Advisory Board Member",
      description: "Mission-driven nearshore BPO center empowering Jamaican talent.",
      url: "https://www.bluemountainbpo.com",
      category: "Outsourcing"
    },
    {
      name: "TPA Auctions",
      role: "Technical Consultant",
      description: "Advanced auction platform leveraging cutting-edge technology.",
      url: "https://www.tpaauctions.com",
      category: "Auction Tech"
    },
    {
      name: "Genii Consultants",
      role: "Co-Founder & Advisory Board Member",
      description: "Elite Salesforce talent acquisition connecting top professionals with leading firms.",
      url: "https://www.geniiconsultants.com",
      category: "Consulting"
    },
    {
      name: "SalesLeopard",
      role: "Partner & Interim CTO",
      description: "Advanced sales intelligence platform powered by cutting-edge analytics.",
      url: "https://salesleopard.com",
      category: "SaaS"
    },
    {
      name: "Plexata",
      role: "Co-Founder",
      description: "NFC-powered smart rings for instant networking. Tap any smartphone to share your digital business card, capture leads, and send automatic follow-ups — no app required.",
      url: "https://www.plexata.com",
      category: "Networking Tech"
    },
    {
      name: "Merc Chem Research",
      role: "Partner",
      description: "Research-use-only laboratory compounds with transparent documentation.",
      category: "Life Sciences"
    },
    {
      name: "Freakfest 2025",
      role: "Partner",
      description: "High-energy festival experience bringing communities together.",
      category: "Entertainment"
    },
    {
      name: "Playhouse Productions",
      role: "Partner",
      description: "EDM production company specializing in music festivals and club shows, delivering high-energy electronic music experiences.",
      url: "https://www.instagram.com/playhouse.productions/",
      category: "Music Production"
    }
  ],
  
  achievements: [
    {
      title: "Music Producer & DJ - JEST3R",
      description: "Big Room House electronic music project. Resident DJ at Marquee, Lavo, and Webster Hall. Played festivals including Imagine, Lost Lands, and Electric Forest",
      icon: "award",
      links: [
        { name: "Website", url: "https://thisisthejest3r.weebly.com/" },
        { name: "Spotify", url: "https://open.spotify.com/artist/3vKt2mLH3Fkp0gZUYbwzFg?si=NHoaxNSfSHqA6rp_fTHkzA" },
        { name: "SoundCloud", url: "https://soundcloud.com/jest3rmusic" },
        { name: "Instagram", url: "https://www.instagram.com/jest3rmusic/" }
      ]
    },
    {
      title: "Music Producer & DJ - Løst Saint",
      description: "Bass House and Tech House production project. Direct support at Dreamforce Afterhours, Hawthorn SF (September 2026)",
      icon: "award",
      links: [
        { name: "SoundCloud", url: "https://soundcloud.com/lost-saint-fm" },
        { name: "Instagram", url: "https://www.instagram.com/lostsaint.fm/" }
      ]
    },
    {
      title: "AI Systems Architect",
      description: "Designs and ships production AI systems: an outbound sales engine that drafts outreach and classifies replies into Salesforce, an editorial pipeline that researches and drafts blog posts for human approval, and knowledge-base chat agents for company websites",
      icon: "bot"
    },
    {
      title: "MMA Fighter",
      description: "Competitive mixed martial arts record of 6-1",
      icon: "trophy",
      link: "https://www.tapology.com/fightcenter/fighters/41920-peter-mcgraw"
    },
    {
      title: "College Athlete",
      description: "Hamilton College Lacrosse Team",
      icon: "medal"
    },
    {
      title: "MIT Blockchain",
      description: "MIT Sloan School of Management - Blockchain Technologies",
      icon: "graduation-cap"
    },
    {
      title: "ABC Certified",
      description: "Mixed Martial Arts Judge & Referee",
      icon: "shield"
    },
    {
      title: "Salesforce Ranger",
      description: "100+ Trailhead Badges",
      icon: "award"
    },
    {
      title: "Web & App Developer",
      description: "Built 14 websites and apps across multiple industries, including Ohana Events, live on the App Store since September 2026",
      icon: "code",
      link: "/web-portfolio"
    }
  ],
  
  skills: [
    "AI Agents & Automation",
    "Digital Transformation",
    "Salesforce Architecture",
    "Mobile App Development",
    "AI & Machine Learning",
    "Blockchain Technology",
    "Strategic Operations",
    "SaaS Development",
    "Cloud Migration",
    "Team Leadership"
  ],
  
  education: [
    {
      institution: "MIT Sloan School of Management",
      focus: "Blockchain Technologies"
    },
    {
      institution: "Syracuse University College of Law",
      focus: "International Business, Trade & Tax Law"
    },
    {
      institution: "Hamilton College",
      focus: "Political Science and Government"
    }
  ]
};